/**
 *
 * SurveysTemplate
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"

import Loader from "components/Loader"
import { map, get } from "lodash"
import {
  Button,
  Divider,
  Input,
  Select,
  Popover,
  Radio,
  Space,
  Tag,
} from "antd"
import ModelsArrow from "../../images/modelsarrow.svg"
import questionIcon from "../../images/question.svg"
import EmptyState from "./EmptyState"
import { ModelItem } from "./modelListItem"
import SurveyBox from "../SurveyBox"
import ModalCustom from "../ModalCustom"
import DimensionBox from "../DimensionBox"
import DimensionBoxEnps from "../DimensionBox/DimensionBoxEnps"

import {
  visitPageSegment,
  PAGE_MODEL_SURVEY,
} from "../../utils/segment/segmentTracks"
import {
  ROLE_AMBASSADOR,
  ROLE_COMPANY_ADMIN,
  ROLE_COMPANY_SUPER_ADMIN,
  SEGMENTS,
} from "../../utils/constants"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import {
  isModuleBySlug,
  LOCAL_ACTIVE_ROL,
  LOCAL_COMPANY_ID,
  LOCAL_USER_ID,
  LOCAL_USER_NAME,
} from "../../utils/storage"
import { buttonAction_context } from "../Snowplow/config2"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
class SurveysTemplate extends React.Component {
  state = {
    modalCreate: false,
    name: "",
    type: "1",
    scopeType: 1,
    manduSurveyDrawer: false,
    idSurveyCopy: "",
    selectedSegments: [],
    clickedModel: false,
    modalDuplicate: false,
  }

  UNSAFE_componentWillMount = () => {
    const isAmbassador = LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR
    const isAdministrator = !!(
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_SUPER_ADMIN ||
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_ADMIN
    )
    
  }

  componentDidMount = () => {
    visitPageSegment(PAGE_MODEL_SURVEY)
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.isLoadingSurveys !== prevProps.isLoadingSurveys) {
      if (this.props.isLoadingSurveys === false) {
        this.setState({
          modalCreate: false,
          modalDuplicate: false,
          name: "",
          type: "1",
        })

        this.setStateFrom("manduSurveyDrawer", false)
      }
    }
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  onToggleCreate = () => {
    this.setState({ modalCreate: !this.state.modalCreate })
  }

  onCreate = () => {
    // woopraTrack("Aceptar Crear Cuestionario")
    buttonAction_context(
      "Aceptar Crear Cuestionario",
      "id_survey_type",
      this.state.type
    )
    const params = {
      name: this.state.name,
      id_survey_type: this.state.type,
      id_scope_type: this.state.scopeType,
      id_company: LOCAL_COMPANY_ID(),
      segments: this.state.selectedSegments,
    }

    

    this.props.createSurvey(params)
    // this.onToggleCreate()
    // this.setState({ name: "", type: "1" })
  }

  duplicateSurvey = (idSurvey, name) => {
    this.setState({
      modalDuplicate: true,
      idSurveyCopy: idSurvey,
      name: `Copia de ${name}`,
    })
  }

  render() {
    const { surveys, leadershipSurveys, surveysByIndicators } = this.props
    const contentSegment = (
      <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
        Especifica a qué segmentos de los creados en el Panel de Control
        aplicará este cuestionario. Luego, al agendar una medición, a los
        colaboradores les llegará el cuestionario asociado a su segmento, para
        el indicador en cuestión.
      </div>
    )
    const forCopy = {
      showFooter: Boolean(this.state.idSurveyCopy),
      showOnlyCancel: Boolean(!this.state.idSurveyCopy),
    }

    const isSegmentsEnabled = isModuleBySlug(SEGMENTS)

    return (
      <div className="quiestionnaries">
        <div className="quiestionnaries-header">
          <h4 className="quiestionnaries-header-title">Cuestionarios</h4>
          <Button
            type="primary"
            className="quiestionnaries-header-button"
            onClick={() => {
              woopraTrack("Crear cuestionario")
              this.onToggleCreate()
            }}>
            + Crear cuestionario
          </Button>
        </div>
        {!this.props.isLoadingSurveysTemplate ? (
          <div className="quiestionnaries-content">
            {surveysByIndicators && surveysByIndicators.length ? (
              <div className="quiestionnaries-content-list">
                {surveysByIndicators.map(
                  (item) =>
                    item.surveys.length > 0 && (
                      <>
                        <div className="quiestionnaries-content-list-title">
                          <span>
                            {item.survey_type_name}
                            {"   "}
                            {item.id_survey_type === 1 && (
                              <span
                                style={{
                                  marginLeft: "8px",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                  background: "rgba(44, 91, 255, 0.1)",
                                  color: "#2C5BFF",
                                  fontWeight: "600",
                                }}>
                                Engagement
                              </span>
                            )}
                          </span>
                          <Divider />
                        </div>
                        <div className="quiestionnaries-content-list-items">
                          {item.surveys &&
                            item.surveys.map((survey, index) => (
                              <SurveyBox
                                isDeletable={survey.is_deletable}
                                history={this.props.history}
                                deleteSurveyWatcher={
                                  this.props.deleteSurveyWatcher
                                }
                                companyLogo={survey.box_company_logo}
                                backgroundImage={survey.box_background_image}
                                duplicateSurveyWatcher={
                                  // this.props.duplicateSurveyWatcher
                                  this.duplicateSurvey
                                }
                                key={index}
                                name={survey.name}
                                idSurvey={survey.id_survey}
                                questions={survey.questions}
                                survey={survey}
                                toggleDrawer={this.setStateFrom}
                                getSurveyWatcher={this.props.getSurveyWatcher}
                                getSurveyEnpsWatcher={
                                  this.props.getSurveyEnpsWatcher
                                }
                                getSurveyQualitativeWatcher={
                                  this.props.getSurveyQualitativeWatcher
                                }
                                downloadSurveyWatcher={
                                  this.props.downloadSurveyWatcher
                                }
                              />
                            ))}
                        </div>
                      </>
                    )
                )}
              </div>
            ) : (
              <EmptyState />
            )}
            <div className="models" style={{ ...(typeof window.Intercom !== "undefined" &&{
        marginBottom: "68px"})}}>
              <div className="models-text">
                <div className="models-text-title">Modelos</div>
                <span>
                  Selecciona un <strong>modelo estándar</strong> que se ajuste a
                  las necesidades de tu organización. Utilizar modelos
                  predeterminados te permitirá reciclar plantillas que han sido
                  exitosas en otras organizaciones de características similares.
                </span>
              </div>
              <div className="models-list">
                {!this.props.isLoadingSurveysTemplate &&
                  map(this.props.surveysTemplate, (item, index) => {
                    return (
                      <ModelItem
                        key={index}
                        item={item}
                        setStateFrom={this.setStateFrom}
                        getSurveyWatcher={this.props.getSurveyWatcher}
                        getSurveyEnpsWatcher={this.props.getSurveyEnpsWatcher}
                        getSurveyQualitativeWatcher={
                          this.props.getSurveyQualitativeWatcher
                        }
                      />
                    )
                  })}
              </div>
              <img src={ModelsArrow} alt="model-arrow" />
            </div>
          </div>
        ) : (
          <Loader />
        )}
        <ModalCustom
          isLoadingButton={this.props.isLoadingSurveys}
          title={
            this.state.clickedModel
              ? get(this.props.surveyName, "name", "Cargando...")
              : "Nuevo cuestionario"
          }
          textButton={this.state.clickedModel ? "Siguiente" : "Crear"}
          model="Cuestionario"
          showFooter
          onOk={() => {
            if (this.state.clickedModel) {
              this.setState({
                modalCreate: false,
                manduSurveyDrawer: true,
              })
            } else {
              this.onCreate()
            }
          }}
          onCancel={() => {
            this.onToggleCreate()
            this.setState({
              name: "",
              type: "1",
              scopeType: 1,
              selectedSegments: [],
              clickedModel: false,
            })
          }}
          disabledButton={
            !this.state.name ||
            !this.state.type ||
            (this.state.scopeType === 2 && !this.state.selectedSegments.length)
          }
          modalOpen={this.state.modalCreate}>
          <div className="newSurveyModal">
            <span style={{ marginBottom: "4px" }}>
              <strong style={{ fontWeight: "600" }}>
                Nombre del cuestionario*:
              </strong>
            </span>
            <Input
              style={{ width: "100%", marginBottom: "16px" }}
              maxLength={46}
              placeholder="Ejemplo: Clima laboral"
              value={this.state.name}
              onChange={(e) => this.setStateFrom("name", e.target.value)}
              /* onKeyPress={(e) => {
                if (e.key === "Enter" && this.state.type) this.onCreate()
              }} */
            />
            <span style={{ marginBottom: "4px" }}>
              <strong style={{ fontWeight: "600" }}>Indicador a medir*:</strong>
            </span>
            {this.state.clickedModel ? (
              <Popover content="No es posible cambiar el tipo de indicador de un modelo predeterminado de Mandü">
                <Select
                  style={{ width: "100%", marginBottom: "16px" }}
                  disabled={this.state.clickedModel}
                  placeholder="Seleccionar tipo"
                  value={this.state.type}
                  onChange={(e) => this.setState({ type: e })}>
                  {this.props.surveysByIndicators.length > 0 &&
                    map(this.props.surveysByIndicators, (item, index) => {
                      return (
                        <Option key={index} value={String(item.id_survey_type)}>
                          {item.survey_type_name}
                        </Option>
                      )
                    })}
                </Select>
              </Popover>
            ) : (
              <Select
                style={{ width: "100%", marginBottom: "16px" }}
                disabled={this.state.clickedModel}
                placeholder="Seleccionar tipo"
                value={this.state.type}
                onChange={(e) => this.setState({ type: e })}>
                {this.props.surveysByIndicators.length > 0 &&
                  map(this.props.surveysByIndicators, (item, index) => {
                    return (
                      <Option key={index} value={String(item.id_survey_type)}>
                        {item.survey_type_name}
                      </Option>
                    )
                  })}
              </Select>
            )}

            {isSegmentsEnabled && (
              <>
                <span style={{ marginBottom: "4px" }}>
                  <strong style={{ fontWeight: "600" }}>Alcance*:</strong>
                  <Popover placement="top" content={contentSegment}>
                    <img src={questionIcon} style={{ marginLeft: 8 }} />
                  </Popover>
                </span>
                <Radio.Group
                  value={this.state.scopeType}
                  onChange={(e) =>
                    this.setState({ scopeType: e.target.value })
                  }>
                  <Space direction="vertical">
                    {map(this.props.scopeTypes, (item, index) => {
                      return (
                        <Radio value={item.id_scope_type}>{item.name}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
                {this.state.scopeType === 2 && (
                  <Select
                    mode="multiple"
                    optionFilterProp="name"
                    allowClear
                    placeholder="Seleccionar segmentos"
                    maxTagCount={3}
                    maxTagTextLength={14}
                    style={{ marginTop: "12px" }}
                    value={this.state.selectedSegments}
                    onChange={(e) => this.setState({ selectedSegments: e })}>
                    {this.props.segments.map((segment, index) => {
                      return (
                        <Option
                          key={index}
                          value={segment.id_segment}
                          name={segment.name}>
                          {segment.name}
                        </Option>
                      )
                    })}
                  </Select>
                )}
              </>
            )}
          </div>
        </ModalCustom>
        <ModalCustom
          isLoadingButton={this.props.isLoadingSurveys}
          title={get(this.props.surveyName, "name", "Cargando...")}
          textButton="Seleccionar"
          textCancelButton="Cerrar"
          width={640}
          {...forCopy}
          onCancel={() => {
            this.setStateFrom("manduSurveyDrawer", false)
            this.setState({
              name: "",
              type: "1",
              scopeType: 1,
              selectedSegments: [],
              clickedModel: false,
            })
          }}
          modalOpen={this.state.manduSurveyDrawer}
          onOk={() => {
            this.props.duplicateSurveyWatcher({
              id_survey: this.state.idSurveyCopy,
              name: this.state.name,
              id_scope_type: this.state.scopeType,
              segments: this.state.selectedSegments,
            })

            // this.setStateFrom("manduSurveyDrawer", false)
          }}
          bodyStyle={{ padding: 0 }}>
          <div style={{ textAlign: "start" }}>
            <div style={{ color: "#555151", padding: "24px 24px 0rem 24px" }}>
              Previsualiza el cuestionario ofrecido por Mandü. Si piensas que
              este se ajusta a las necesidades de tu organización, selecciónalo
              para utilizarlo en tu proceso de medición de clima laboral.
            </div>
            <Divider />
            {this.props.isLoadingSurvey ? (
              <Loader height={window.innerHeight > 590 ? "400px" : "280px"} />
            ) : (
              <div
                style={{
                  padding: "0 24px 0",
                  overflow: "scroll",
                  maxHeight: window.innerHeight > 590 ? "400px" : "280px",
                }}>
                {map(this.props.surveySelected, (item, index) => {
                  return (
                    <DimensionBox
                      key={index}
                      item={item}
                      hideTag
                      hideDescripion
                    />
                  )
                })}
                {!!get(this.props.surveyQualitative, "data", []).length && (
                  <DimensionBoxEnps
                    hideDescripion
                    hideSwitch
                    measures={get(this.props.surveyName, "measures", [])}
                    idSurvey={this.props.match.params.id}
                    item={this.props.surveyQualitative}
                    toggleDrawer={this.setStateFrom}
                    updateQualitativeWatcher={
                      this.props.updateQualitativeWatcher
                    }
                    getQuestionWatcher={this.props.getQuestionWatcher}
                    updateQuestionDimensionWatcher={
                      this.props.updateQuestionDimensionWatcher
                    }
                    getQuestionTypesWatcher={this.props.getQuestionTypesWatcher}
                    // isSurveyMandu={get(this.props.survey[0], 'dimension_icon_image', '')}
                    showOptionsChildren
                  />
                )}
                {!!get(this.props.surveyEnps, "data", []).length && (
                  <DimensionBoxEnps
                    hideDescripion
                    hideSwitch
                    measures={get(this.props.surveyName, "measures", [])}
                    updateQuestionWatcher={this.props.updateQuestionWatcher}
                    toggleDrawer={this.setStateFrom}
                    item={this.props.surveyEnps}
                    getQuestionWatcher={this.props.getQuestionWatcher}
                    getQuestionTypesWatcher={this.props.getQuestionTypesWatcher}
                    hideThreePoints
                    enps
                    updateQuestionDimensionWatcher={
                      this.props.updateQuestionDimensionWatcher
                    }
                    // isSurveyMandu={get(this.props.survey[0], 'dimension_icon_image', '')}
                  />
                )}
              </div>
            )}
          </div>
        </ModalCustom>
        <ModalCustom
          title="Duplicar cuestionario"
          textButton="Duplicar"
          model="Cuestionario"
          isLoadingButton={this.props.isLoadingSurveys}
          showFooter
          onOk={() => {
            this.props.duplicateSurveyWatcher({
              id_survey: this.state.idSurveyCopy,
              name: this.state.name,
              id_scope_type: this.state.scopeType,
              segments: this.state.selectedSegments,
            })
          }}
          onCancel={() => {
            this.setState({
              name: "",
              type: "1",
              scopeType: 1,
              selectedSegments: [],
              clickedModel: false,
              modalDuplicate: false,
            })
          }}
          disabledButton={
            !this.state.name ||
            !this.state.type ||
            (this.state.scopeType === 2 && !this.state.selectedSegments.length)
          }
          modalOpen={this.state.modalDuplicate}>
          <div className="newSurveyModal">
            <span style={{ marginBottom: "4px" }}>
              <strong style={{ fontWeight: "600" }}>
                Nombre del cuestionario*:
              </strong>
            </span>
            <Input
              style={{ width: "100%", marginBottom: "16px" }}
              maxLength={46}
              placeholder="Ejemplo: Clima laboral"
              value={this.state.name}
              onChange={(e) => this.setStateFrom("name", e.target.value)}
              /* onKeyPress={(e) => {
                if (e.key === "Enter" && this.state.type) this.onCreate()
              }} */
            />
            {isSegmentsEnabled && (
              <>
                <span style={{ marginBottom: "4px" }}>
                  <strong style={{ fontWeight: "600" }}>Alcance*:</strong>
                  <Popover placement="top" content={contentSegment}>
                    <img src={questionIcon} style={{ marginLeft: 8 }} />
                  </Popover>
                </span>
                <Radio.Group
                  value={this.state.scopeType}
                  onChange={(e) =>
                    this.setState({ scopeType: e.target.value })
                  }>
                  <Space direction="vertical">
                    {map(this.props.scopeTypes, (item, index) => {
                      return (
                        <Radio value={item.id_scope_type}>{item.name}</Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
                {this.state.scopeType === 2 && (
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Seleccionar segmentos"
                    maxTagCount={3}
                    maxTagTextLength={14}
                    style={{ marginTop: "12px" }}
                    value={this.state.selectedSegments}
                    onChange={(e) => this.setState({ selectedSegments: e })}>
                    {this.props.segments.map((segment, index) => {
                      return (
                        <Option key={index} value={segment.id_segment}>
                          {segment.name}
                        </Option>
                      )
                    })}
                  </Select>
                )}
              </>
            )}
          </div>
        </ModalCustom>
      </div>
    )
  }
}

SurveysTemplate.propTypes = {}

export default SurveysTemplate
